// extracted by mini-css-extract-plugin
export default {"indicatorNew":"IndicatorNew_indicatorNew__4Spko"};